export default __webpack_public_path__ + "static/media/bwBrainwellness.0afe878d.svg";